<template>
  <two-column-layout
      tab-selector="scenetab"
      type="scene"
      back-button-tab-selector="scenebackbutton"
      :id="$route.params.id"
      sub-menu-selector="librarypanel"
  >
    <div slot="buttonsLeft"/>

    <info-panel
        slot="sidebarLeft"
        :id="$route.params.id"
        upload-type="Asset"
        :created="$store.getters.getSceneCreationDate($route.params.id)"
        :last-change="$store.getters.getSceneChangeDate($route.params.id)"
        :downloadable="true"
        :removable="true"
        :image-editable="hasWritingAccess"
        preview-id="sceneEdit"
        :organization="$store.getters.getSceneOrganization($route.params.id)"
        :preview-uri="$store.getters.getScenePreviewUri(this.$route.params.id)"
    />
    <team-attacher
        v-if="$store.getters.getSceneOrganization($route.params.id)"
      slot="sidebarLeft"
              class="mt-3"
              :id="$route.params.id"
              :teams="teams"
              store-name="Asset"
              :read-only="!hasWritingAccess"
              :limit-by-organization-id="$store.getters.getSceneOrganization($route.params.id)"
              @added="loadAssetTeams"
              @removed="loadAssetTeams"
          />
    <info-panel
        slot="sidebarLeft"
        :id="$route.params.id"
        :tags="$store.getters.getSceneTags($route.params.id)"
        :taggable="hasWritingAccess"
        preview-id="sceneEdit"
        @removeTag="removeTag"
        @addTag="addTag"
        :key="'infopanel2'"
        :limit-tags-to-organization="$store.getters.getSceneOrganization($route.params.id)"
    />

    <div slot="mainContent">
      <name-display-edit-block
          :max-name-length="500"
          v-if="$store.getters.getSceneTitle($route.params.id)"
          :name="$store.getters.getSceneTitle($route.params.id)"
          :display-name="$store.getters.getSceneDisplayName($route.params.id)"
          :id="$route.params.id"
          store-name="Scene"
          :editable="hasWritingAccess"
          :organization-id="$store.getters.getSceneOrganization($route.params.id)"
      />
      <content-description-block
          :value="$store.getters.getSceneDescription(id)"
          :id="$route.params.id"
          store-name="Scene"
          :editable="hasWritingAccess"
      />
      <div v-if="$store.getters.isSFXMember || $store.getters.isSuperAdmin" class="row">
        <state-setter
            class="col-12 col-md-4 mb-2 mt-2"
            :target-id="$route.params.id"
            store-name="Scene"
            :given-state="$store.getters.getScenesByListName($route.params.id).state"
        />
      </div>
      <meta-set-attacher
          :target-id="$route.params.id"
          store-name="Asset"
          @added="loadScene"
          @removed="loadScene"
          :given-meta-sets="$store.getters.getSceneMetaSets(id)"
      />
      <meta-panel
          :key="item.id"
          v-for="(item) in $store.getters.getSceneMetaSets(id)"
          :title="item.description"
          :fields="item.metaFields"
          icon-left="folder"
          store-name="Scene"
          :editable="hasWritingAccess"
          :organization-ids="[$store.getters.getSceneOrganization(id)]"
           @updated="loadScene"
      />
    </div>
  </two-column-layout>
</template>

<script>
import InfoPanel from "../components/InfoPanel";
import TwoColumnLayout from "../layouts/OneColumnSidebarLeft";
import MetaPanel from "../components/widgets/meta/MetaPanel";
import ContentDescriptionBlock from "../components/ContentDescriptionBlock";
import MetaSetAttacher from "@/components/widgets/meta/MetaSetAttacher";
import TeamAttacher from "@/components/organizations/TeamAttacher";
import NameDisplayEditBlock from "@/components/NameDisplayEditBlock.vue";
import StateSetter from "@/components/StateSetter.vue";

export default {
  name: 'SceneEdit',
  components: {
    StateSetter,
    MetaPanel,
    InfoPanel,
    TwoColumnLayout,
    ContentDescriptionBlock,
    MetaSetAttacher,
    TeamAttacher,
    NameDisplayEditBlock
  },
  data() {
    return {
      id: '',
      teams: [],
      hasWritingAccess: false,
    };
  },
  beforeMount() {
    this.loadScene();
    this.loadAssetTeams();
    this.id = this.$route.params.id;
  },
  methods: {
    loadAssetTeams() {
      this.$store.dispatch('clientLoadAssetTeams', {
        id: this.$route.params.id
      }).then(data => {
        this.teams = data;
      });
    },
    async checkAccess(item) {
      this.hasWritingAccess = await this.$store.dispatch('checkTeamOrgPermission', {
        op: 'write',
        teams: item.teams || [],
        organizationId: item.organizationId
      });
    },
    loadScene() {
      this.$store.dispatch('loadScene', {
        id: this.$route.params.id,
        include: 'metaSets,tags,teams'
      }).then(data => {
        this.checkAccess(data);
      }).catch(e => {
        if(e.status === 401) {
          this.$router.push('/access-denied');
        } else if(e.status === 404) {
          this.$router.push('/not-found')
        }
      });
    },
    removeTag: function(tag) {
      this.$store.dispatch('removeSceneTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
    addTag: function(tag) {
      this.$store.dispatch('addSceneTag', {
        id: this.$route.params.id,
        args: [tag.id],
      });
    },
  },
}
</script>